import { render } from "./Withdrawals.vue?vue&type=template&id=a93c8f38&scoped=true"
import script from "./Withdrawals.vue?vue&type=script&lang=js"
export * from "./Withdrawals.vue?vue&type=script&lang=js"

import "./custom-withdrawals.scss?vue&type=style&index=0&id=a93c8f38&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a93c8f38"]])

export default __exports__